import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Välj spelare", -1)
const _hoisted_2 = ["label"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange())),
    name: "events",
    id: "events",
    class: "form-select mt-6 block w-full border p-3 rounded",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.playerId) = $event))
  }, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (e) => {
      return (_openBlock(), _createElementBlock("optgroup", {
        key: e.id,
        label: e.event,
        class: _normalizeClass(e.id)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.players, (p) => {
          return (_openBlock(), _createElementBlock("option", {
            key: p.id,
            value: p.id
          }, _toDisplayString(p.name), 9, _hoisted_3))
        }), 128))
      ], 10, _hoisted_2))
    }), 128))
  ], 544)), [
    [_vModelSelect, _ctx.playerId]
  ])
}